import { render, staticRenderFns } from "./NewPoliciesCard.vue?vue&type=template&id=3538fb7c&scoped=true"
import script from "./NewPoliciesCard.vue?vue&type=script&lang=ts"
export * from "./NewPoliciesCard.vue?vue&type=script&lang=ts"
import style0 from "./NewPoliciesCard.vue?vue&type=style&index=0&id=3538fb7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538fb7c",
  null
  
)

export default component.exports